import axios from 'axios';
import MyMaskInput from 'components/form/MyMaskInput';
import { formatError } from 'components/utils/FormatData';
import React, { useState } from 'react';
import { useAlert } from 'react-alert';
import { URL_API } from '../../constants/settings';

const TypeProfilRenderer = (props) => {
  const alert = useAlert();
  const [gravity, setGravity] = useState(props.value);
  const [originValue, setOriginValue] = useState(props.value);
  const [valueChanged, setValueChanged] = useState(false);

  const handleOnChange = (value) => {
    if (value) {
      setGravity(value);
      setValueChanged(Number(value) !== originValue);
    } else {
      setGravity(0);
      setValueChanged(0 !== originValue);
    }
  }
  const handleOnBlur = () => {
    axios({ method: 'put', url: URL_API + '/types-alarme/' + props.data.code + '/indice', params: { indice: gravity } })
      .then(function (response) {
        setOriginValue(response.data);
        setValueChanged(false);
      })
      .catch(function (err) {
        formatError(alert, err);
      });
  }

  return (
    <>
      {
        props.wsStatus &&
        <MyMaskInput
          placeholder=""
          type="text"
          className="input-style-my-currency"
          value={gravity}
          onChange={(e) => handleOnChange(e.target.value)}
          onBlur={() => handleOnBlur()}
          maskOptions={{
            prefix: '',
            suffix: '',
            decimalSymbol: '.',
            decimalLimit: 2,
            integerLimit: 1,
            includeThousandsSeparator: false,
            allowNegative: false,
          }}
          style={{
            margin: '10px',
            width: '75px',
            backgroundColor: valueChanged ? '#edf4da' : '',
            color: valueChanged ? '#89a63a' : '',
            fontWeight: 'bold'
          }}
        />
      }
      {
        !props.wsStatus &&
        <div className="input-style-my-currency" style={{
          backgroundColor: 'rgb(128 128 128 / 50%)', color: 'grey', width: '75px', height: '35px', display: 'flex',
          justifyContent: 'center', alignItems: 'center'
        }}>
          <b>{gravity}</b>
        </div>
      }
    </>
  );


};

export default TypeProfilRenderer;